import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageWrapper } from "../../../../shared/layout";
import { Button } from "../../../../shared/widgets";
import { editOperatorConfigAction, fetchOperatorConfigAction } from "../../../../redux/action-creators/operatorConfigEditActionCreator";
import OperatorConfigModal from "./OperatorConfigModal";
import { operatorTypes } from "../../../../Constant";
import "./operatorConfig.css";

function OperatorConfigChange() {
  const location = useLocation();
  const dispatch = useDispatch();
  const city = location.state?.city;
  const rowData = location.state?.rowData;
  const [selectedOperator, setSelectedOperator] = useState(rowData?.operatorId || 0);
  const [toggles, setToggles] = useState([]);
  const [originalToggles, setOriginalToggles] = useState([]);

  const availableConfigs = useSelector(
    (state) => state.OperatorSettlementConfig?.cityOperatorsList?.availableConfigs || [],
  );
  const operatorConfigList = useSelector(
    (state) => state?.operatorConfigEdit?.operatorConfigData || [],
  );

  const safeOperatorConfigList = Array.isArray(operatorConfigList) ? operatorConfigList : [];

  useEffect(() => {
    const mapped = operatorTypes.map((type) => {
      const backendEntry = safeOperatorConfigList.find((d) => d.config === type.config);
      return {
        ...type,
        enabled: backendEntry ? backendEntry.enabled : false,
      };
    });
    setToggles(mapped);
    setOriginalToggles(mapped);
  }, [safeOperatorConfigList]);

  const handleToggleChange = (configKey) => {
    setToggles((prev) => prev.map((item) => (item.config === configKey
      ? { ...item, enabled: !item.enabled } : item)));
  };

  const hasChanges = toggles.some((item, idx) => {
    const orig = originalToggles[idx];
    return orig && item.enabled !== orig.enabled;
  });

  const handleSubmit = async () => {
    if (hasChanges) {
      const changedToggles = toggles.filter((item, idx) => {
        const orig = originalToggles[idx];
        return orig && item.enabled !== orig.enabled;
      });
      const payload = {
        operatorId: rowData?.operatorId,
        toggles: changedToggles.map((item) => ({
          enabled: item.enabled,
          type: item.type,
          config: item.config,
          target: item.target,
        })),
      };
      await dispatch(editOperatorConfigAction(payload));
      dispatch(fetchOperatorConfigAction({
        operatorId: rowData?.operatorId,
      }));
    }
  };

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header heading={`${rowData?.displayName || ""} , ${city?.cityName || ""}`} removeFilterOnly="false" hideS showBackArrow>
          <div className="fieldContainer">
            <div style={{ marginBottom: 16 }}>
              <div className="operatorHeading">
                Operator App Config
              </div>
              {toggles.map((option) => (
                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                <label
                  key={option.config}
                  className="labelContainer"
                >
                  <div className="optionContainer">
                    <span style={{ minWidth: 120 }}>
                      {option.label}
                    </span>
                    <input
                      type="checkbox"
                      checked={option.enabled}
                      onChange={() => handleToggleChange(option.config)}
                      className="checkboxContainer"
                    />
                  </div>
                </label>
              ))}
            </div>
            <div className="pull-right">
              <Button
                classname="submitBtnContainer"
                onClick={handleSubmit}
                buttonText="Submit"
                disabled={!hasChanges}
              />
            </div>
            <hr />
            <OperatorConfigModal
              selected={selectedOperator}
              setSelected={setSelectedOperator}
              selectedCity={city}
              availableConfigs={availableConfigs}
              rowData={rowData}
            />
          </div>
        </PageWrapper.Header>
      </PageWrapper>
    </div>
  );
}

export default OperatorConfigChange;
